export default __webpack_public_path__ + "static/media/MINIFavicon.ca8cd04c.ico";